import { AIButtonIcon as AIButtonIconButton } from '../../AIButton'
import { INLINE_BUTTON_SIZES } from '../Buttons'
import { Container } from '../Container'

import PlusIcon from '../../../icons/plus.svg'

export function AIButtonIcon() {
  return (
    <>
      <Container label='AI Button, icon, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <AIButtonIconButton Icon={PlusIcon} height={size} key={size} />
        ))}
      </Container>
      <Container label='AI Button, icon, disabled, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <AIButtonIconButton
            disabled
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, icon, with loader, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <AIButtonIconButton
            isLoading
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, icon, with skeleton, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <AIButtonIconButton
            isSkeleton
            Icon={PlusIcon}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
